import Vue from 'vue'
import Router from 'vue-router'

import AdminLayout from '../layouts/AdminLayout.vue'
import Login from '../views/auth/Login.vue'
import Dashboard from '../views/dashboard/index.vue'
import Devices from '../views/devices/index.vue'
import Peers from '../views/peers/index.vue'
import Proxies from '../views/proxies/index.vue'
import ProxyAdmin from '../views/proxyAdmin/index.vue'
import Users from '../views/users/index.vue'
import Settings from '../views/settings/index.vue'
import { isAuthed } from '../utils/auth'

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: { public: true, title: 'Đăng nhập' }
    },
    {
      path: '/',
      component: AdminLayout,
      redirect: '/dashboard',
      meta: { requiresAuth: true },
      children: [
        {
          path: 'dashboard',
          name: 'dashboard',
          component: Dashboard,
          meta: { title: 'Tổng quan Dashboard', icon: 'el-icon-data-analysis', requiresAuth: true }
        },
        {
          path: 'devices',
          name: 'devices',
          component: Devices,
          meta: { title: 'Devices', icon: 'el-icon-monitor', requiresAuth: true }
        },
        {
          path: 'peers',
          name: 'peers',
          component: Peers,
          meta: { title: 'Peer Devices', icon: 'el-icon-connection', requiresAuth: true }
        },
        {
          path: 'proxies',
          name: 'proxies',
          component: Proxies,
          meta: { title: 'Proxies', icon: 'el-icon-share', requiresAuth: true }
        },
        {
          path: 'proxy-admin',
          name: 'proxy-admin',
          component: ProxyAdmin,
          meta: { title: 'Proxy Admin', icon: 'el-icon-lock', requiresAuth: true }
        },
        {
          path: 'users',
          name: 'users',
          component: Users,
          meta: { title: 'Users', icon: 'el-icon-user', requiresAuth: true }
        },
        {
          path: 'settings',
          name: 'settings',
          component: Settings,
          meta: { title: 'Settings', icon: 'el-icon-setting', requiresAuth: true }
        }
      ]
    },
    { path: '*', redirect: '/dashboard' }
  ]
})

// Auth guard
// - Nếu chưa login mà vào route cần auth -> chuyển /login?redirect=...
// - Nếu đã login mà vào /login -> chuyển /dashboard
router.beforeEach((to, from, next) => {
  const authed = isAuthed()

  if (to.path === '/login') {
    if (authed) return next('/dashboard')
    return next()
  }

  const requiresAuth = to.matched.some(r => r.meta && r.meta.requiresAuth)
  if (requiresAuth && !authed) {
    return next({ path: '/login', query: { redirect: to.fullPath } })
  }

  next()
})

export default router





// WEBPACK FOOTER //
// ./src/router/index.js